import { EventEmitter } from 'events';

const OnUpdateEventEmitter = new EventEmitter();

export function emitOnUpdate(selectNext = true) {
  OnUpdateEventEmitter.emit('change-state', { selectNext: selectNext || false });
}

export function onUpdateEventEmitterService(listener) {
  OnUpdateEventEmitter.on('change-state', listener);
  return () => {
    OnUpdateEventEmitter.removeListener('change-state', listener);
  };
}
